<template>
<DIV
  v-if="loaded"
>
  <div
    class="form-group"
  >
    <ItpFormInput
      :autofocus="!isReadonly"
      name="name"
      v-model="item.name"
      :placeholder="'Name'|pgettext('InvoiceParty')"
      :readonly="isReadonly"
      required
    >
    </ItpFormInput>
  </div>
  <div
    class="form-row"
    v-if="item.address"
  >
    <div
      class="form-group col-2"
    >
      <ItpFormInput
        name="postal_code"
        v-model="item.address.postal_code"
        :placeholder="'Postal code'|pgettext('InvoiceParty')"
        :readonly="isReadonly"
      >
      </ItpFormInput>
    </div>
    <div
      class="form-group col-10"
    >
      <ItpFormInput
        name="city"
        v-model="item.address.city"
        :placeholder="'City'|pgettext('InvoiceParty')"
        :readonly="isReadonly"
      >
      </ItpFormInput>
    </div>
  </div>
  <div
    class="form-group"
    v-if="item.address"
  >
    <ItpFormInput
      name="address"
      v-model="item.address.address"
      :placeholder="'Address'|pgettext('InvoiceParty')"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </div>
  <div
    class="form-group"
  >
    <ItpFormInput
      name="tax_number"
      v-model="item.tax_number"
      :placeholder="'Tax number'|pgettext('InvoiceParty')"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </div>
  <div
    class="form-group"
  >
    <ItpFormInput
      name="account_number"
      v-model="item.account_number"
      :placeholder="'Account number'|pgettext('InvoiceParty')"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </div>
  <div
    class="form-group"
  >
    <ItpFormInput
      name="bank"
      v-model="item.bank"
      :placeholder="'Bank'|pgettext('InvoiceParty')"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </div>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetInvoiceParty extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onReferenceInvoiceSelected(...args: any[]) {
    const { option, value } = args[0];

    this.selectClient({ clientId: option.client.id })
  }

  selectClient(...args: any[]) {
    const { clientId } = args[0];
    return this.$fn
      .fetch('get_invoice_party_details', { parameters: { id: clientId } })
      .then(data => this.setData('invoice.client', data))
      .catch(err => this.onError(err))
  }

  selectCompany(...args: any[]) {
    const { companyId } = args[0];
    return this.$fn
      .fetch('get_invoice_party_details', { parameters: { id: companyId } })
      .then(data => this.setData('invoice.company', data))
      .catch(err => this.onError(err))
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return false
    }
    return null;
  }

  get item() {
    if (this.loaded) {

      return this.invoice[this.path]
    }
    return null;
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("FieldsetInvoiceParty", FieldsetInvoiceParty);

</script>